import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import logo from "../../assets/images/logo.svg";
import {
  faBagShopping,
  faChevronLeft,
  faPlusCircle,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import newtouLogoNoText from "../../assets/images/newtou-logo-no-text.svg";
import { useLocation, useNavigate } from "react-router-dom";

export const TopNavigation = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="h-[7.5vh] w-[100vw] flex flex-row text-[0.7rem] px-4  justify-between items-center">
        <div className="flex">
          <img src={logo} alt="logo" className="w-[8rem]" />
        </div>
        <div className="flex justify-center items-center">
          <button
            className="h-fit ml-4"
            onClick={() => {
              navigate("/create-post");
            }}
          >
            <FontAwesomeIcon
              icon={faPlusCircle}
              className="w-[2rem]"
              color="#FF000F"
            />
          </button>
        </div>
      </div>
    </>
  );
};
